import { ProjectFinancialService } from './services/projectFinancial.service';
import { ConsultantsReportComponent } from './views/reports/consultants-report/consultants-report.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule, JsonpModule } from '@angular/http';
import { HttpClientModule, HttpClient as AngularHttpClient } from '@angular/common/http';

import { AppComponent } from "./views/app.component";
import { AdminLayoutComponent } from "./layout/admin/admin-layout.component";


import { AppRoutes } from "./app.routing";
import { SharedModule } from "./shared/shared.module";

import { LoginComponent } from "./views/login/login.component";
import { ConsultantsComponent } from "./views/consultants/consultants.component";
import { ConsultantsKenobyComponent } from './views/consultants/consultants-kenoby/consultants-kenoby.component';
import { ApprovalsComponent } from "./views/approvals/approvals.component";
import { CompaniesComponent } from "./views/companies/companies.component";
import { CompanyGroupComponent } from "./views/companies/company-group/company-group.component";

import { AuthService } from "./services/auth.service";
import { Json2csvService } from "./services/json2csv.service";
import { HttpClient } from "./shared/wrappers/HttpClient";
import { LocalStorage } from "./shared/wrappers/LocalStorage";

import { AuthGuard } from "./shared/AuthGuard";

import { LoginProvider } from "./shared/providers/login.provider";
import { UserProvider } from "./shared/providers/user.provider";
import { ConsultantCreateComponent } from "./views/consultants/consultant-create/consultant-create.component";
import { ConsultantService } from "./services/consultant.service";
import { CompanieCreateComponent } from "./views/companies/companie-create/companie-create.component";
import { CompanyTemporaryComponent } from './views/companies/company-temporary/company-temporary.component';

import { ConsultantEditComponent } from "./views/consultants/consultant-edit/consultant-edit.component";
import { ApprovalCreateComponent } from "./views/approvals/approvals-create/approvals-create.component";
import { ApprovalEditComponent } from "./views/approvals/approvals-edit/approvals-edit.component";
import { UserService } from "./services/user.service";
import { NgDatepickerModule } from "ng2-datepicker";

import { CompaniesService } from './services/companies.service';

import { NgxPaginationModule } from 'ngx-pagination';
import { NotificationService } from './services/notification.service';
import { SnackbarComponent } from './shared/components/snackbar/snackbar.component';
import { BillingLetterCreateComponent } from './views/billing-letter/billing-letter-create/billing-letter-create.component';
import { BillingLetterComponent } from './views/billing-letter/billing-letter.component';
import { BillingLetterService } from './services/billing-letter/billing-letter.service';
import { Cnae } from './shared/enums/billing-letter/Cnae';
import { CnaeSupplier } from './shared/enums/CnaeSupplier';
import { SignersClickSignEnum } from './shared/enums/signersClickSign';
import { ContractTypesEnum, NewContractTypesEnum } from './shared/enums/ContractType.enum';
import { CompaniesEditComponent } from './views/companies/companies-edit/companies-edit.component';

import { ApprovalService } from './services/approval.service';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import { HashtrackService } from './services/hashTrack.service';
import { CompanyMatchComponent } from './views/companies/company-match/company-match.component';
import { ProductService } from './services/product.service';
import { CnaeService } from './services/cnae.service';
import { PurchaseOrderService } from './services/purchaseOrder.service';
import { CurrencyMaskModule } from "ng2-currency-mask";
import { ToastModule } from 'ng2-toastr/ng2-toastr';

import { CompanyService } from "./services/billing-letter/company.service";
import { OwnerService } from "./services/billing-letter/owner.service";

import { DivisionsProvider } from "./shared/providers/enums/divisions.provider";
import { StatusProvider } from "./shared/providers/enums/billing-letter/status-provider";
import { CompetenceProvider } from "./shared/providers/enums/billing-letter/competence-provider";
import { NatureProvider } from "./shared/providers/enums/nature.provider";
import { ValueClassProvider } from "./shared/providers/enums/value-class.provider";
import { BillingLetterProvider } from "./shared/providers/billing-letter-steps.provider";
import { CommonHelper } from "./shared/helpers/CommonHelper";
import { DashboardService } from './services/dashboard.service';
import { BillingLetterEditComponent } from './views/billing-letter/billing-letter-edit/billing-letter-edit.component';
import { AccountingPeriodBlockService } from './services/accountingBlock.service';
import { ErrorHandlerProvider } from './shared/providers/errorHandler.provider';

import { FormatName } from "./shared/pipes/format-name.pipe";
import { UrlBuilderFactory } from "./shared/factories/url-builder.factory"
import { FormatEmpty } from "./shared/pipes/format-empty.pipe";
import { FactoryModule } from "./shared/factories/factory.module";
import { EnumModule } from "./shared/enums/enum.module";
import { CostByProjectReportComponent } from "./views/reports/cost-by-project-report/cost-by-project-report.component";
import {BillingLettersReportComponent} from "./views/reports/billing-letters-report/billing-letters-report.component";
import {RefundsReportComponent} from "./views/refunds-report/refunds-report.component";
import { CostProjectService } from "./services/cost-project.service";
import { RefundsService } from "./services/refund.service";
import { FormatMonth } from "./shared/pipes/format-month.pipe";
import { ChartsModule } from 'ng2-charts';
import { ProjectListingComponent } from './views/approvals/project-listing/project-listing.component';
import { ConsultantListingComponent } from './views/approvals/consultant-listing/consultant-listing.component';
import { UiSwitchModule } from 'ng2-ui-switch';
import { LogComponent } from './views/log/log.component';
import {LogService} from "./services/log.service";
import {LogFiltersFactory} from "./shared/factories/logs/filters.factory";
import { NotificationsComponent } from './views/notifications/notifications.component';
import {UserNotificationService} from "./services/user-notification.service";
import { NotificationFactory} from "./shared/factories/notifications/notifications.factory";
import { EditMultiApprovalsComponent } from './views/approvals/edit-multi-approvals/edit-multi-approvals.component';
import { ApprovalBoxComponent } from './views/approvals/approval-box/approval-box.component';
import { CreateApprovalBoxComponent } from './views/approvals/create-approval-box/create-approval-box.component';
import { TooltipModule } from 'ngx-tooltip';
import { ProjectsComponent } from './views/projects/projects.component';
import { ProjectCreateComponent } from './views/projects/project-create/project-create.component';
import { ProjectEditComponent } from './views/projects/project-edit/project-edit.component';
import { TextMaskModule } from 'angular2-text-mask';
import { ConsultantFilterFactory } from './shared/factories/consultants/filters.factory';
import { OptionsConsultants } from './shared/enums/consultants/OptionsConsultant';
import { CostFiltersFactory } from './shared/factories/cost/filters.factory';
import { RefundFiltersFactory } from './shared/factories/refunds/filters.factory';
import { ProjectCostIncomeComponent } from './views/projects/project-cost-income/project-cost-income.component';
import { AwsService } from './services/aws.service';
import { CnpjService } from './services/cnpj.service';
import { ArchiveComponent } from './views/archive/archive/archive.component';
import { ArchiveService } from './services/archive/archive.service';
import { ArchiveDetailsComponent } from './views/archive/archive/archive-details/archive-details.component';
import { ConsultantCardComponent } from './views/archive/archive/consultant-card/consultant-card.component';
import { AuthComponent } from './views/auth/auth.component';
import { RefundDetailComponent } from './views/refunds-report/refund-detail/refund-detail.component';
import { ProductsIncomeComponent } from './views/products/products-cost-income/products-cost-income.component';
import { CnaesComponent } from './views/cnaes/cnaes.component';
import { CnaeCreateComponent } from './views/cnaes/cnaes-create/cnaes-create.component';
import { CnaeEditComponent } from './views/cnaes/cnaes-edit/cnaes-edit.component';
import { PurchaseOrderComponent } from './views/purchase-order/purchase-order.component';
import { PurchaseOrderCreateComponent } from './views/purchase-order/purchase-order-create/purchase-order-create.component';
import { PurchaseOrderDetailComponent } from './views/purchase-order/purchase-order-detail/purchase-order-detail.component';
import { PurchaseOrderHierarchyComponent } from './views/purchase-order/purchase-order-hierarchy/purchase-order-hierarchy.component';
import { CompanyTemporaryCreateComponent } from './views/companies/company-temporary/company-temporary-create/company-temporary-create.component';
import { BankService } from './services/bank.service';
import { InvoiceAttachComponent } from './views/invoice-attach/invoice-attach.component';
import { InvoiceAttachService } from './services/invoice-attach.service';
import { ModalPdfComponent } from "./shared/components/modal-pdf/modal-pdf.component";
import { ConfirmModalComponent } from "./shared/components/confirm-modal/confirm-modal.component"
import { SignerModalComponent } from './shared/components/signer-modal/signer-modal.component';
import { ProjectsCostCreateComponent } from './views/project-cost/project-cost-create/projects-cost-create.component';
import { PixValidation } from './shared/helpers/PixValidation';
import { PublicConsultantEditComponent } from './views/consultants/public-consultant-edit/public-consultant-edit.component';
import { PublicConsultantService } from './services/public-consultant.service';
import { ProjectCostService } from './services/project-cost.service';
import { UtilsProjectCost } from './views/project-cost/utils';
import { UsersModule } from './views/users/users.module';
import { kenobyConsultantService } from './services/kenobyConsultants.service';
import { UsersCreateComponent } from './views/users/users-create/users-create.component';
import { UsersEditComponent } from './views/users/users-edit/users-edit.component';
import { TeamGroupsService } from './services/teamGroups.service';
import { ModalBorrowedNote } from './views/consultants/modal-borrowed-note/modal-borrowed-note';
import { IndustriesService } from './services/industries.service';
import { ExcellenceCentersService } from './services/excellenceCenters.service'
import { ModalApportionmentComponent } from './shared/components/apportionment/modalApportionment.component';
import { ModalParcelsComponent } from './views/billing-letter/components/modal-parcels/modal-parcels.component';
import { BillingParcelService } from './services/billing-letter/billing-parcel.service';

import { LegalCertificateComponent } from './views/legalCertificate/legalCertificate.component';
import { LegalCertificateService } from './services/legalCertificate.service';
import { LegalCertificateCreateComponent } from './views/legalCertificate/legalCertificate-create/legalCertificate-create.component';
import { LegalCertificateEditComponent } from './views/legalCertificate/legalCertificate-edit/legalCertificate-edit.component';
import { HomeComponent } from './views/home/home.component';
import { DashboardComponent } from './views/dashboard/dashboard.component';
import { DashboardFinanceComponent } from './views/dashboard/dashboard-finance/dashboard-finance.component';
import { DashboardJudiciaryComponent } from './views/dashboard/dashboard-judiciary/dashboard-judiciary.component';
import { AccountingBlockComponent } from './shared/components/accounting-block/accounting-block.component';
import { SelfFillModalComponent } from './shared/components/self-fill-modal/self-fill-modal.component';
import { ModalCompareDataComponent } from './views/consultants/components/modalCompareData/modalCompareData.component';
import { ModalAdditiveComponent } from './views/consultants/components/modalAdditive/modalAdditive.component';
import { ProductType } from './shared/enums/billing-letter/productType';

import { CompanyInventoryService } from './services/companyInventory.service';
import { CompanyInventoryComponent } from './views/companies/company-inventory/companyInventory.component';
import { ContractTypesService } from './services/contractTypes.service';
import { CompanyInventoryCreateComponent } from './views/companies/company-inventory/company-inventory-create/company-inventory.component-create'
import { CompanyInventoryEditComponent } from './views/companies/company-inventory/company-inventory-edit/company-inventory.component-edit'
import { AddContractTypeComponent } from './views/companies/company-inventory/modal-add-contract-type/add-contract-type.component';
import { ApprovalsUploadComponent } from "./views/approvals/approvals-upload/approvals-upload.component";
import { VendorInventoryService } from './services/vendorInventory.service';
import { VendorInventoryComponent } from './views/companies/vendor-inventory/vendorInventory.component';
import { VendorInventoryCreateComponent } from './views/companies/vendor-inventory/vendor-inventory-create/vendor-inventory.component-create';
import { VendorInventoryEditComponent } from './views/companies/vendor-inventory/vendor-inventory-edit/vendor-inventory.component-edit';

import { ModalFreshServiceOffiboarding } from './views/consultants/components/modalFreshServiceOffboarding/modalFreshServiceOffboarding';
import { LeaveTypesSubGroup } from './shared/enums/LeaveTypes.enum';

import { TreeviewModule } from "ngx-treeview";
import { PurchaseOrderListDetailComponent } from './views/purchase-order/components/purchase-order-list-detail/purchase-order-list-detail.component';
import { FileManagerService } from './services/file-manager.service';
import { UserAdProfileService } from './services/user-ad-profile.service';

@NgModule({
    declarations: [
        AppComponent,
        AdminLayoutComponent,
        ConsultantsComponent,
        ConsultantsKenobyComponent,
        ConsultantsReportComponent,
        BillingLettersReportComponent,
        ApprovalsComponent,
        CompaniesComponent,
        CompanyGroupComponent,
        ConsultantCreateComponent,
        ConsultantEditComponent,
        PublicConsultantEditComponent,
        ApprovalCreateComponent,
        UsersCreateComponent,
        UsersEditComponent,
        ApprovalEditComponent,
        CompanieCreateComponent,
        SnackbarComponent,
        CompanyMatchComponent,
        CompaniesEditComponent,
        CostByProjectReportComponent,
        RefundsReportComponent,
        BillingLetterCreateComponent,
        BillingLetterEditComponent,
        BillingLetterComponent,
        LoginComponent,
        InvoiceAttachComponent,
        FormatName,
        FormatEmpty,
        FormatMonth,
        ApprovalsUploadComponent,
        ProjectListingComponent,
        ConsultantListingComponent,
        LogComponent,
        NotificationsComponent,
        EditMultiApprovalsComponent,
        ApprovalBoxComponent,
        CreateApprovalBoxComponent,
        ProjectsComponent,
        ProjectCreateComponent,
        ProjectEditComponent,
        ProjectCostIncomeComponent,
        ArchiveComponent,
        ArchiveDetailsComponent,
        ConsultantCardComponent,
        AuthComponent,
        RefundDetailComponent,
        CnaesComponent,
        CnaeCreateComponent,
        CnaeEditComponent,
        ProductsIncomeComponent,
        PurchaseOrderComponent,
        PurchaseOrderCreateComponent,
        PurchaseOrderDetailComponent,
        PurchaseOrderHierarchyComponent,
        CompanyTemporaryComponent,
        CompanyTemporaryCreateComponent,
        ModalPdfComponent,
        ConfirmModalComponent,
        SignerModalComponent,
        ProjectsCostCreateComponent,
        LegalCertificateComponent,
        LegalCertificateEditComponent,
        LegalCertificateCreateComponent,
        SignerModalComponent,
        ModalBorrowedNote,
        ModalApportionmentComponent,
        ModalParcelsComponent,
        HomeComponent,
        DashboardComponent,
        AccountingBlockComponent,
        SelfFillModalComponent,
        ModalCompareDataComponent,
        DashboardFinanceComponent,
        DashboardJudiciaryComponent,
        CompanyInventoryComponent,
        CompanyInventoryCreateComponent,
        CompanyInventoryEditComponent,
        AddContractTypeComponent,
        ModalAdditiveComponent,
        VendorInventoryComponent,
        VendorInventoryCreateComponent,
        VendorInventoryEditComponent,
        ModalApportionmentComponent,
        ModalFreshServiceOffiboarding,
        PurchaseOrderListDetailComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(AppRoutes),
        SharedModule,
        FormsModule,
        HttpModule,
        JsonpModule,
        NgDatepickerModule,
        NgxPaginationModule,
        AngularMultiSelectModule,
        ReactiveFormsModule,
        CurrencyMaskModule,
        ToastModule.forRoot(),
        FactoryModule,
        EnumModule,
        ChartsModule,
        UiSwitchModule,
        TooltipModule,
        TextMaskModule,
        UsersModule,
        TreeviewModule.forRoot(),
        HttpClientModule,
    ],
    providers: [
        AuthGuard,
        AuthService,
        HttpClient,
        LocalStorage,
        LoginProvider,
        UserProvider,
        ConsultantService,
        PublicConsultantService,
        CompaniesService,
        UserService,
        NotificationService,
        BillingLetterService,
        AccountingPeriodBlockService,
        ErrorHandlerProvider,
        kenobyConsultantService,
        Cnae,
        CnaeSupplier,
        SignersClickSignEnum,
        ProductType,
        ContractTypesEnum,
        NewContractTypesEnum,
        Json2csvService,
        ApprovalService,
        HashtrackService,
        ProductService,
        CnaeService,
        PurchaseOrderService,
        CompanyService,
        OwnerService,
        DivisionsProvider,
        StatusProvider,
        CompetenceProvider,
        NatureProvider,
        ValueClassProvider,
        BillingLetterProvider,
        CommonHelper,
        PixValidation,
        DashboardService,
        UrlBuilderFactory,
        CostProjectService,
        RefundsService,
        LogService,
        LogFiltersFactory,
        UserNotificationService,
        NotificationFactory,
        ProjectFinancialService,
        ConsultantFilterFactory,
        OptionsConsultants,
        CostFiltersFactory,
        RefundFiltersFactory,
        AwsService,
        CnpjService,
        ArchiveService,
        BankService,
        LegalCertificateService,
        InvoiceAttachService,
        ProjectCostService,
        UtilsProjectCost,
        TeamGroupsService,
        IndustriesService,
        ExcellenceCentersService,
        BillingParcelService,
        CompanyInventoryService,
        VendorInventoryService,
        ContractTypesService,
        ExcellenceCentersService,
        IndustriesService,
        LeaveTypesSubGroup,
        FileManagerService,
        { provide: LocationStrategy, useClass: PathLocationStrategy },
        { provide: LOCALE_ID, useValue: 'pt-BR' },
        { provide: AngularHttpClient, useClass: AngularHttpClient },
        UserAdProfileService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts